/**
 * Formatarea navlului ofertat (Ocean Freight) pe listele de import
 * (conosamente și containere). Valoarea vine din backend, calculată exclusiv
 * din oferta atribuită / prețurile manuale — nu din costurile interne.
 */

export interface QuotedOceanFreightLike {
  oceanFreightAmount?: number | null;
  oceanFreightCurrency?: string | null;
  /** Doar la conosamente: codul B/L-ului pe care au fost numărate containerele acestui rând. */
  oceanFreightOnBl?: string | null;
}

export function hasQuotedOceanFreight(row: QuotedOceanFreightLike): boolean {
  return typeof row.oceanFreightAmount === 'number' && Number.isFinite(row.oceanFreightAmount);
}

/**
 * Textul din celula Ocean Freight (import). `—` = fără ofertă.
 * „Apare pe X" = containerele acestui B/L sunt deja numărate pe B/L-ul X al aceluiași booking.
 */
export function formatQuotedOceanFreight(row: QuotedOceanFreightLike, lang: 'ro' | 'en'): string {
  if (!hasQuotedOceanFreight(row)) {
    const code = (row.oceanFreightOnBl || '').trim();
    if (row.oceanFreightOnBl != null) {
      if (code) return lang === 'ro' ? `Apare pe ${code}` : `Shown on ${code}`;
      return lang === 'ro' ? 'Apare pe alt B/L' : 'Shown on another B/L';
    }
    return '—';
  }
  const formatted = new Intl.NumberFormat(lang === 'ro' ? 'ro-RO' : 'en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(row.oceanFreightAmount as number);
  const currency = (row.oceanFreightCurrency || 'USD').trim() || 'USD';
  return `${formatted} ${currency}`;
}
